jQuery(function ($) {
	$('#primary').has('.page-default-title').addClass('has-page-default-title');
});
